import Dashboard from "../pages/dashboard/Dashboard";
import Dashboard2 from "../pages/dashboard/Dashboard2";
import EnhancedDashboard from "../pages/dashboard/EnhancedDashboard";
import AnalyticsDashboard from "../pages/dashboard/AnalyticsDashboard";
import ClaudeAnalysis from "../pages/claudeAnalysis/ClaudeAnalysis";
import DashboardMatrixAnalytics from "../pages/dashboard/DashboardMatrixAnalytics";
import DailyConsultPerformance from "../pages/dashboard/DailyConsultPerformance";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { FaUserAlt, FaUsers } from "react-icons/fa";
// import ProductManagement from '../pages/productManagement/ProductManagement'
import UserManagement from "../pages/userManagement/UserManagement";
import {
  auth,
  user,
  consultant,
  dashboard,
  category,
  banner,
  ecommerce,
  music,
  meditation,
  training,
  image,
  cms,
  vastuCompass,
  gift,
  community,
  explore,
  refer,
  request,
  discount,
  horoscope,
  live,
  notification,
  support,
  feedback,
  form,
  concern,
  transaction,
  offers,
  offerEngine,
  consultantPayout,
  shopify,
  commission,
  subadmin,
  marketing,
  waitlist,
  failed,
  Missed,
  Completed,
  Progress,
  Onlineoffline,
  FlagRequest,
  bookedwaitlist,
  insight,
  management,
  analytics,
  purchaseAnalytics,
  settings,
  segment,
  playstoreScreenshot,
  utmManagement,
  customerProblem,
  activityLog,
  cronJobs,
  couponsV2,
  influencerManagement,
  powerCustomer,
} from "./route";
import ActivityLogPage from "../pages/activityLog/ActivityLog";
import CronJobsPage from "../pages/cronJobs/CronJobs";
import ScheduleIcon from "@mui/icons-material/Schedule";
import UserDetail from "../pages/userManagement/UserDetail";
import Category from "../pages/category/Category";
import QrCodeIcon from "@mui/icons-material/QrCode";
import common from "../routes/common";
import MantraList from "../pages/category/mantra/MantraList";
import BannerList from "../pages/bannerManagement/BannerList";
import MusicCategoryList from "../pages/musicManagement/MusicCategoryList";
import MusicList from "../pages/musicManagement/music/MusicList";
import MeditationCategoryList from "../pages/meditationManagement/MeditationCategoryList";
import MeditationList from "../pages/meditationManagement/meditation/MeditationList";
import ConsultantList from "../pages/consultantManagement.jsx/ConsultantList";
import PreSelectedConsultant from "../pages/consultantManagement.jsx/PreSelectedConsultant";
import AstrologerRegistrationFormList from "../pages/consultantManagement.jsx/AstrologerRegistrationForm";
import ConsultantDetail from "../pages/consultantManagement.jsx/ConsultantDetail";
import TrainingList from "../pages/trainingManagement/Training/TrainingList";
import TrainingCategoryList from "../pages/trainingManagement/TrainingCategoryList";
import ImageList from "../pages/imageManagement/ImageList";
import ImageDetail from "../pages/imageManagement/ImageDetail";
import CmsManagement from "../pages/cmsManagement/CmsManagement";
import VastuCompassCategory from "../pages/vastuCompassCategory/VastuCompassCategory";
import ViewVastuCompass from "../pages/vastuCompassCategory/ViewVastuCompass";
import AddConsultant from "../pages/consultantManagement.jsx/AddConsultant";
import GiftManagement from "../pages/giftManagement/GiftManagement";
import CommunityManagement from "../pages/communityManagement/CommunityManagement";
import CommunityDetail from "../pages/communityManagement/CommunityDetail";
import ExploreManagement from "../pages/exploreManagement/ExploreManagement";
import ViewExplore from "../pages/exploreManagement/ViewExplore";
import EditConsultant from "../pages/consultantManagement.jsx/EditConsultant";
import EditConsultantV1 from "../pages/consultantManagement.jsx/EditConsultantV1";
import ReferManagement from "../pages/referManagement/ReferManagement";
import RequestManagement from "../pages/requestManagement/RequestManagement";
import MediaList from "../pages/category/media/MediaList";
import DiscountManagement from "../pages/discount/DiscountManagement";
import HoroscopeManagement from "../pages/horoscopeManagement/HoroscopeManagement";
import ViewHoroscope from "../pages/horoscopeManagement/ViewHoroscope";
import LiveManagement from "../pages/liveManagement/LiveManagement";
import Notification from "../pages/notificationManagement/Notification";
import AddNotification from "../pages/notificationManagement/AddNotification";
import SupportManagement from "../pages/supportManagement/SupportManagement";
import AddSupport from "../pages/supportManagement/AddSupport";
import ViewSupport from "../pages/supportManagement/ViewSupport";
import SupportQueryMasters from "../pages/supportManagement/SupportQueryMasters";
import FeedbackManagement from "../pages/feedbackManagement/FeedbackManagement";
import Form from "../pages/form/Form";
import GoToChat from "../pages/communityManagement/GoToChat";
import ConcernManagement from "../pages/concern&Remedy/ConcernManagement";
import RemedyList from "../pages/concern&Remedy/remedy/RemedyList";
import TransactionManagement from "../pages/transaction/TransactionManagement";
import OffersManagement from "../pages/offersManagement/OffersManagement";
import CheckPerformance from "../pages/consultantManagement.jsx/CheckPerformance";
import ConsultantKPI from "../pages/consultantManagement.jsx/ConsultantKPI";
import ConsultantPerformance from "../pages/consultantPerformance/ConsultantPerformance";
import ConsultantPerformanceAlerts from "../pages/consultantPerformance/ConsultantPerformanceAlerts";
import OperationsEcosystem from "../pages/operationsEcosystem/OperationsEcosystem";
import PowerCustomerReturn from "../pages/powerCustomerReturn/PowerCustomerReturn";
import ConsultantPayout from "../pages/consultantPayout/ConsultantPayout";
import Settings from "../pages/settings/Settings";
import Shopify from "../pages/shopify/Shopify";
import ConsultantCommission from "../pages/consultantCommission/ConsultantCommission";
import SubAdmin from "../pages/subAdmin/SubAdmin";
import AddSubadmin from "../pages/subAdmin/AddSubadmin";
import SegmentList from "../pages/segmentManagement/SegmentList";
import SegmentBuilder from "../pages/segmentManagement/SegmentBuilder";
import SegmentDetail from "../pages/segmentManagement/SegmentDetail";
import ViewSubadmin from "../pages/subAdmin/ViewSubadmin";
import EditSubadmin from "../pages/subAdmin/EditSubadmin";
import DeleteConsultant from "../pages/consultantManagement.jsx/DeleteConsultant";
import DeleteUser from "../pages/userManagement/DeleteUser";
import Medication from "../pages/meditationManagement/Meditation";
import MeditationDashboard from "../pages/meditationManagement/MeditationDashboard";
import Explore from "../pages/exploreManagement/Explore";
import UserExploreActivity from "../pages/exploreManagement/UserExploreActivity";
import MarketingManagement from "../pages/marketingManagement/marketingManagement";
import ZodiacMessageManagement from "../pages/zodiacMessageManagement/ZodiacMessageManagement";
import WaitlistManagement from "../pages/waitlistmanagement/WaitlistManagement";
import FailedConsultation from "../pages/failedconsultation/failedconsultationmangement";
import MissedCall from "../pages/MissedChat/Missedcallchat";
import ProgressCall from "../pages/progessCallChat/ProgessConstulation";
import CompletedCall from "../pages/completeCallChat/CompleteConstulation";
import OnlineOffflineconsultant from "../pages/onlineofflineconsultant/onlineoffline";
import FlagReview from "../pages/flagrequest/FlagRequest";
import BookedWaitlistManagement from "../pages/bookedwaitlist/BookedWaitlist";
import InsightManagement from "../pages/insightManagement/InsightManagement";
import UserInsight from "../pages/insightManagement/userInsight";
import ConsultantInsight from "../pages/insightManagement/consultantInsight";
import Management from "../pages/management/Management";
import AnalyticsManagement from "../pages/analyticsManagement/AnalyticsManagement";
import PurchaseAnalytics from "../pages/purchaseAnalytics/PurchaseAnalytics";
import UsersByPurchaseCount from "../pages/purchaseAnalytics/UsersByPurchaseCount";
import UserAnalytics from "../pages/analyticsManagement/UserAnalytics";
import DeviceAnalytics from "../pages/analyticsManagement/DeviceAnalytics";
import PlaystoreScreenshotManagement from "../pages/playstoreScreenshotManagement/PlaystoreScreenshotManagement";
import UTMManagement from "../pages/utmManagement/UTMManagement";
import CustomerProblemIdentification from "../pages/customerProblemIdentification/CustomerProblemIdentification";
import OfferVariantList from "../pages/offerEngine/OfferVariantList";
import OfferRuleList from "../pages/offerEngine/OfferRuleList";
import CouponsV2Management from "../pages/couponsV2/CouponsV2Management";
import InfluencerManagement from "../pages/influencerManagement/InfluencerManagement";
import InfluencerDetail from "../pages/influencerManagement/InfluencerDetail";
import EcommerceManagement from "../pages/ecommerceManagement/EcommerceManagement.jsx";
import PowerCustomer from "../pages/powerCustomer/PowerCustomer";
import { canAccessOpsEcosystem, canAccessPowerCustomerReturn } from "../utils/operationsEcosystemAccess";

const { FORGET_PASSWORD_ROUTE, RESET_PASSWORD_ROUTE } = auth;
const { DASHBOARD, DASHBOARD_2, DASHBOARD_MATRIX_ANALYTICS, DAILY_CONSULT_PERFORMANCE, CLAUDE_DATA_ANALYSIS } = dashboard;
const { USER_MANAGEMENT, USER_DETAIL, USER_DELETE } = user;
const { SETTINGS } = settings;
const {
  CONSULTANT_MANAGEMENT,
  PRE_SELECTED_CONSULTANT,
  ASTROLOGER_REGISTRATION_FORM,
  CONSULTANT_DETAIL,
  CONSULTANT_ADD,
  CONSULTANT_EDIT,
  CONSULTANT_EDIT_V1,
  CONSULTANT_CHECK_PERFORMANCE,
  CONSULTANT_KPI,
  CONSULTANT_DELETE,
  CONSULTANT_PERFORMANCE,
  CONSULTANT_PERFORMANCE_ALERTS,
  OPERATIONS_ECOSYSTEM,
  POWER_CUSTOMER_RETURN
} = consultant;
const { WAITLIST_MANAGEMENT } = waitlist;
const { BOOKED_WAITLIST } = bookedwaitlist;
const { FAILED_CONSULTATION } = failed;
const { MISSED_CALL_CHAT } = Missed;
const { COMPLETED_CALL_CHAT, COMPLETED_QUERIES } = Completed;
const { PROGRESS_CALL_CHAT } = Progress;
const { ONLINE_OFFLINE_CONSULTANT } = Onlineoffline;
const { FLAG_REQUEST } = FlagRequest;
const { CATEGORY, ADD_MEDIA } = category;
const { BANNER } = banner;
const { ECOMMERCE } = ecommerce;
const { MUSIC_LIST, MUSIC_DETAIL } = music;
const { MEDITATION_LIST, MEDITATION_DETAIL, MEDITATION_CATEGORY_LIST, MEDITATION_DASHBOARD } = meditation;
const { TRAINING_LIST, TRAINING_DETAIL } = training;
const { IMAGE_LIST, IMAGE_DETAIL } = image;
const { CONTENT_MANAGEMENT } = cms;
const { VASTU_COMPASS_CATEGORY, VASTU_COMPASS_CATEGORY_DETAIL } = vastuCompass;
const { GIFT_MANAGEMENT } = gift;
const { COMMUNITY_MANAGEMENT, COMMUNITY_DETAIL, COMMUNITY_CHAT } = community;
const { EXPLORE_MANAGEMENT, EXPLORE_DETAIL, EXPLORE_LIST, USER_ACTIVITY_LOG } = explore;
const { REFER_MANAGEMENT } = refer;
const { REQUEST_MANAGEMENT } = request;
const { DISCOUNT_MANAGEMENT } = discount;
const { HOROSCOPE_MANAGEMENT, VIEW } = horoscope;
const { LIVE_MANAGEMENT } = live;
const { NOTIFICATION_MANAGEMENT, ADD_NOTIFICATION } = notification;
const { SUPPORT_MANAGEMENT, ADD_SUPPORT, VIEW_SUPPORT, QUERY_MASTERS } = support;
const { FEEDBACK_MANAGEMENT } = feedback;
const { SEGMENT_LIST, SEGMENT_BUILDER, SEGMENT_DETAIL } = segment;
const { FORM } = form;
const { SHOPIFY } = shopify;
const { CONCERN, CONCERN_DETAIL } = concern;
const { TRANSACTION } = transaction;
const { OFFERS } = offers;
const { OFFER_VARIANTS, OFFER_RULES } = offerEngine;
const { MARKETING } = marketing;
const { PAYOUT } = consultantPayout;
const { COMMISSION } = commission;
const { SUBADMIN, ADDSUBADMIN, EDITSUBADMIN, VIEWSUBADMIN } = subadmin;
const { INSIGHT, USER_INSIGHT, CONSULTANT_INSIGHT } = insight;
const { MANAGEMENT } = management;
const { ANALYTICS, USER_ANALYTICS, DEVICE_ANALYTICS } = analytics;
const { PURCHASE_ANALYTICS, USERS_BY_PURCHASE_COUNT } = purchaseAnalytics;
const { PLAYSTORE_SCREENSHOT } = playstoreScreenshot;
const { UTM_MANAGEMENT } = utmManagement;
const { CUSTOMER_PROBLEM } = customerProblem;
const { ACTIVITY_LOG } = activityLog;
const { CRON_JOBS } = cronJobs;
const { POWER_CUSTOMER } = powerCustomer;
const roleIsAdmin = (role) =>
  String(role || "")
    .trim()
    .toLowerCase() === "admin";

/** Sub-admin: only explicit `true` grants access. Admin: all modules. */
const { COUPONS_V2 } = couponsV2;
const {
  INFLUENCER_LIST,
  INFLUENCER_DETAIL,
} = influencerManagement;
const showModule = (key, role) => {
  if (roleIsAdmin(role)) {
    return true;
  }
  return key === true;
};

/** Own keys win when stored. If they were never set, fall back to the parent section. */
const showOwnOrInherited = (rightsInfo, role, ownKeys, inheritKeys) => {
  if (roleIsAdmin(role)) return true;
  const ownValues = ownKeys.map((key) => rightsInfo?.[key]);
  if (ownValues.some((value) => value === true)) return true;
  if (ownValues.some((value) => value === false)) return false;
  return inheritKeys.some((key) => rightsInfo?.[key] === true);
};

/** Menus that were open to every login stay visible until access is explicitly turned off. */
const showUnlessRevoked = (rightsInfo, role, key) => {
  if (roleIsAdmin(role)) return true;
  return rightsInfo?.[key] !== false;
};

const canAccessPreSelectedConsultant = (rightsInfo, role) =>
  roleIsAdmin(role) ||
  rightsInfo?.["pre-selected-consultant-management"] === true;

const canAccessConsultantProfileFromPreSelected = (rightsInfo, role) =>
  roleIsAdmin(role) ||
  rightsInfo?.["consultant-management"] === true ||
  rightsInfo?.["pre-selected-consultant-management"] === true;

const canAccessConsultantPayout = (rightsInfo, role) =>
  roleIsAdmin(role) ||
  rightsInfo?.["consultant-payout-management"] === true ||
  rightsInfo?.["bank-pan-request-management"] === true ||
  rightsInfo?.["bank-pan-record-management"] === true;

/** Sub-admin with only marketing-dashboard-management: allow only these paths in the menu. */
const marketingOnlySidebarPaths = (rightsInfo, role) => {
  if (roleIsAdmin(role)) return null;
  if (String(role || "").trim().toLowerCase() !== "sub-admin") return null;
  if (rightsInfo?.["marketing-dashboard-management"] !== true) return null;
  const hasOther = Object.entries(rightsInfo || {}).some(
    ([k, v]) => k !== "marketing-dashboard-management" && v === true
  );
  if (hasOther) return null;
  return [DASHBOARD_2, POWER_CUSTOMER, `${USER_DETAIL}/:id`];
};

/** "Other Management" hub: show only if admin or any submodule right is granted */
const MANAGEMENT_HUB_RIGHT_KEYS = [
  "music-management",
  "meditation-management",
  "training-management",
  "gallery-management",
  "content-management",
  "ecommerce-management",
  "vastu-management",
  "gift-management",
  "community-management",
  "discount-management",
  "feedback-management",
  "concern-management",
  "offers-management",
  "purchase-analytics-management",
];

const canAccessManagementHub = (rightsInfo, role) => {
  if (roleIsAdmin(role)) return true;
  return MANAGEMENT_HUB_RIGHT_KEYS.some((k) => rightsInfo?.[k] === true);
};

export const sidebar = (rightsInfo = {}, role) => {
  const allSidebar = [

    {
      id: 101,
      enabled: showModule(rightsInfo?.["dashboard-management"], role),
      name: "Dashboard",
      path: DASHBOARD,
      icon: common.DASHBOARD_ICON,
      isChild: null,
    },
    {
      id: 1018,
      enabled: showOwnOrInherited(
        rightsInfo,
        role,
        ["daily-consult-performance", "daily-consult-performance-management"],
        ["dashboard-management"]
      ),
      name: "Daily Consult Performance",
      path: DAILY_CONSULT_PERFORMANCE,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 1019,
      enabled: roleIsAdmin(role) || rightsInfo?.["marketing-dashboard-management"] === true,
      name: "Power Customer",
      path: POWER_CUSTOMER,
      icon: common.POWER_CUSTOMER_ICON,
      isChild: null,
    },
    {
      id: 100,
      // enabled: true,
      enabled: showModule(rightsInfo?.["transaction-management"], role),
      name: "Transaction Management",
      path: TRANSACTION,
      icon: common.TRANSACTION_ICON,
      isChild: null,
    },
    {
      id: 120,
      enabled: showModule(rightsInfo["support-management"], role),
      // enabled: true,
      name: "Support Management",
      path: SUPPORT_MANAGEMENT,
      icon: common.SUPPORT_ICON,
      isChild: null,
    },
    {
      id: 147,
      enabled: showModule(rightsInfo?.["customer-problem-management"], role),
      name: "Customer Problem Identification",
      path: CUSTOMER_PROBLEM,
      icon: common.USER_ICON,
      isChild: null,
    },



    {
      id: 102,
      // enabled: true,
      enabled: showModule(
        rightsInfo["user-management"],
        role,

      ),
      name: "User Management",
      path: USER_MANAGEMENT,
      icon: common.USER_ICON,
      isChild: null,
    },
    {
      id: 103,
      enabled: showModule(rightsInfo["consultant-management"], role),
      name: "Consultant Management",
      path: CONSULTANT_MANAGEMENT,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 1032,
      enabled: canAccessPreSelectedConsultant(rightsInfo, role),
      name: "Pre Selected Consultant",
      path: PRE_SELECTED_CONSULTANT,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 1033,
      enabled: showOwnOrInherited(
        rightsInfo,
        role,
        ["astrologer-registration", "astrologer-registration-management"],
        ["pre-selected-consultant-management"]
      ),
      name: "Astrologer Registration Form",
      path: ASTROLOGER_REGISTRATION_FORM,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 1031,
      enabled: false,
      name: "Consultant Performance",
      path: CONSULTANT_PERFORMANCE,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 1034,
      enabled: showOwnOrInherited(
        rightsInfo,
        role,
        ["performance-alerts", "performance-alerts-management"],
        ["consultant-management"]
      ),
      name: "Performance Alerts",
      path: CONSULTANT_PERFORMANCE_ALERTS,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 1035,
      enabled: canAccessOpsEcosystem(rightsInfo, role),
      name: "Operations Ecosystem",
      path: OPERATIONS_ECOSYSTEM,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 1036,
      enabled: canAccessPowerCustomerReturn(rightsInfo, role),
      name: "Power Customer Return",
      path: POWER_CUSTOMER_RETURN,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 104,
      enabled: showModule(rightsInfo["waitlist-management"], role),
      name: "Waitlist Management",
      path: WAITLIST_MANAGEMENT,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 105,
      enabled: showModule(rightsInfo["failed-consultation"], role),
      name: "Cancelled Consultation",
      path: FAILED_CONSULTATION,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 106,
      enabled: showModule(rightsInfo["missed-call-chat"], role),
      name: "Missed Chat/Call",
      path: MISSED_CALL_CHAT,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 10997,
      enabled: showModule(rightsInfo["progress-call-chat"], role),
      name: "Progress Chat/Call",
      path: PROGRESS_CALL_CHAT,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 10998,
      enabled: showModule(rightsInfo["completed-call-chat"], role),
      name: "Completed Chat/Call",
      path: COMPLETED_CALL_CHAT,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 10999,
      enabled: showOwnOrInherited(
        rightsInfo,
        role,
        ["completed-queries", "completed-queries-management"],
        ["completed-call-chat", "completed-call-chat-management"]
      ),
      name: "Completed Queries",
      path: COMPLETED_QUERIES,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 106,
      enabled: showModule(rightsInfo["online-offline-consultant"], role),
      name: "Consultant Online/offline",
      path: ONLINE_OFFLINE_CONSULTANT,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 107,
      enabled: showModule(rightsInfo["flag-request"], role),
      name: "Flag Requests",
      path: FLAG_REQUEST,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 108,
      enabled: showOwnOrInherited(
        rightsInfo,
        role,
        ["booked-waitlist", "booked-waitlist-management"],
        ["waitlist-management"]
      ),
      name: "Booked Session-Waitlist",
      path: BOOKED_WAITLIST,
      icon: common.CONSULTANT_ICON,
      isChild: null,
    },
    {
      id: 1003,
      // enabled: true,
      enabled: showModule(rightsInfo["shopify-commission-management"], role),
      name: "Shopify Commission",

      path: COMMISSION,
      icon: common.COMMISSION,
      isChild: null,
    },
    {
      id: 104,
      // enabled: true,
      name: "Expertise Management",
      enabled: showModule(rightsInfo["expertise-management"], role),
      path: CATEGORY,
      icon: common.CATEGORY_ICON,
      isChild: null,
    },
    {
      id: 105,
      // enabled: true,
      name: "Banner Management",
      enabled: showModule(rightsInfo["banner-management"], role),
      path: BANNER,
      icon: common.CATEGORY_ICON,
      isChild: null,
    },
    {
      id: 1051,
      name: "Ecommerce Management",
      enabled: showModule(rightsInfo["ecommerce-management"], role),
      path: ECOMMERCE,
      icon: common.CATEGORY_ICON,
      isChild: null,
    },
    //sub admin
    {
      id: 10009,
      // enabled: true,
      enabled: showModule(rightsInfo["sub-admin-management"], role),
      name: "Subadmin Management",
      path: SUBADMIN,
      icon: common.SUBADMIN_ICON,
      isChild: null,
    },

    // expl
    {
      id: 10010,
      enabled: showModule(rightsInfo?.["explore-management"], role),
      name: "Explore Management",
      path: EXPLORE_MANAGEMENT,
      icon: common.EXPLORE_ICON,
      isChild: null,
    },
    // refer management
    {
      id: 10011,
      enabled: showModule(rightsInfo?.["refer-management"], role),
      name: "Refer Management",
      path: REFER_MANAGEMENT,
      icon: common.REFER_ICON,
      isChild: null,
    },
    // request management
    {
      id: 10012,
      enabled: showModule(rightsInfo?.["request-management"], role),
      name: "Request Management",
      path: REQUEST_MANAGEMENT,
      icon: common.REQUEST_ICON,
      isChild: null,
    },
    // live management
    {
      id: 10013,
      enabled: showModule(rightsInfo?.["live-management"], role),
      name: "Live Management",
      path: LIVE_MANAGEMENT,
      icon: common.LIVE_ICON,
      isChild: null,
    },
    // notification management
    {
      id: 10014,
      enabled: showModule(rightsInfo?.["notification-management"], role),
      name: "Notification Management",
      path: NOTIFICATION_MANAGEMENT,
      icon: common.NOTIFICATION_ICON,
      isChild: null,
    },
    //add sub admin
    // {
    //   id: 117,
    //   enabled: true,
    //   name: "Horoscope Management",
    //   path: HOROSCOPE_MANAGEMENT,
    //   icon: common.HOROSCOPE_ICON,
    //   isChild: null,
    // },



    // {
    //   id: 119,
    //   enabled: true,
    //   name: "Form 16A",
    //   path: FORM,
    //   icon: common.FORM_ICON,
    //   isChild: null,
    // },
    {
      id: 123,
      // enabled: true,
      enabled: showModule(rightsInfo?.["marketing-management"], role),
      name: "Marketing Purpose",
      path: MARKETING,
    },
    {
      id: 124,
      enabled: showModule(rightsInfo?.["zodiac-message-management"], role),
      name: "Zodiac Message Management",
      path: "/zodiac-message-management",
      icon: common.OFFERS_ICON,
      isChild: null,
    },
    /// transaction management
    {
      id: 102,
      enabled: canAccessManagementHub(rightsInfo, role),
      name: "Other Management",
      path: MANAGEMENT,
      icon: common.MANAGEMENT_ICON,
      isChild: null,
    },
    {
      id: 141,
      enabled: showModule(rightsInfo["insight-management"], role),
      name: "Insight Management",
      path: INSIGHT,
      icon: common.INSIGHT_ICON,
      isChild: null,
    },
    {
      id: 142,
      enabled: showModule(rightsInfo["analytics-management"], role) || role === "admin",
      name: "Analytics Management",
      path: ANALYTICS,
      icon: common.INSIGHT_ICON,
      isChild: null,
    },
    // Segment Management
    {
      id: 143,
      enabled: showModule(rightsInfo?.["segment-management"], role) || role === "admin",
      name: "Segment Management",
      path: SEGMENT_LIST,
      icon: common.SEGMENT_ICON,
      isChild: null,
    },
    {
      id: 123,
      enabled: canAccessConsultantPayout(rightsInfo, role),
      // enabled: rightsInfo["consultant-payout"] || role === "admin",
      // enabled: rightsInfo?.consultant-payout || role === "admin",

      name: "Consultant Payout",
      path: PAYOUT,
      icon: common.PAYOUT_ICON,
      isChild: null,
    },
    {
      id: 144,
      enabled: showModule(rightsInfo?.["playstore-screenshot-management"], role) || role === "admin",
      name: "Playstore Screenshot Management",
      path: PLAYSTORE_SCREENSHOT,
      icon: common.SUPPORT_ICON,
      isChild: null,
    },
    {
      id: 145,
      enabled: showModule(rightsInfo?.["utm-management"], role),
      name: "UTM Management",
      path: UTM_MANAGEMENT,
      icon: common.EXPLORE_ICON,
      isChild: null,
    },
    // {
    //   id: 300,
    //   enabled: true,
    //   name: "Offer Variants",
    //   path: OFFER_VARIANTS,
    //   icon: common.OFFERS_ICON,
    //   isChild: null,
    // },
    {
      id: 301,
      enabled: showUnlessRevoked(rightsInfo, role, "offer-management"),
      name: "Offer Management",
      path: OFFER_RULES,
      icon: common.OFFERS_ICON,
      isChild: null,
    },
    // ── V2 Coupon System ──────────────────────────────────────────────────────
    {
      id: 302,
      enabled: showUnlessRevoked(rightsInfo, role, "coupon-management-v2"),
      name: "🎟 Coupon Management V2",
      path: COUPONS_V2,
      icon: common.OFFERS_ICON,
      isChild: null,
    },
    {
      id: 303,
      enabled: showUnlessRevoked(rightsInfo, role, "influencer-management"),
      name: "🌟 Influencer Management",
      path: INFLUENCER_LIST,
      icon: common.USER_ICON,
      isChild: null,
    },
    {
      id: 200,
      enabled: showModule(rightsInfo?.["settings-management"], role),
      name: "Settings",
      path: SETTINGS,
      icon: common.SETTINGS_ICON,
      isChild: null,
    },
    {
      id: 1017,
      enabled: showModule(rightsInfo?.["dashboard-matrix-analytics"], role),
      name: "Dashboard Matrix Analytics",
      path: DASHBOARD_MATRIX_ANALYTICS,
      icon: common.DASHBOARD_ICON,
      isChild: null,
    },
    //   name: "Settings",
    //   path: SETTINGS,
    //   icon: common.SETTINGS_ICON,
    //   isChild: null,
    // },
    // {
    //   id: 104,
    //   enabled: true,
    //   name: 'Category Management',
    //   path: 'category',
    //   icon: <QrCodeIcon sx={{ fontSize: 18 }} />,
    //   isChild: [
    //     {
    //       id: 4001,
    //       enabled: true,
    //       name: 'Category',
    //       path: '/category-management',
    //       icon: <CategoryIcon sx={{ fontSize: 18 }} />,
    //     },
    //     {
    //       id: 4002,
    //       enabled: true,
    //       name: 'Sub Category',
    //       path: '/sub-category',
    //       icon: <BabyChangingStationIcon sx={{ fontSize: 18 }} />,
    //     },
    //   ],
    // },

    // {
    //   id: 106,
    //   enabled: true,
    //   name: 'Bidder Management',
    //   path: '/bidder-management',
    //   icon: <Person3RoundedIcon sx={{ fontSize: 18 }} />,
    //   isChild: null,
    // },

    // {
    //   id: 107,
    //   enabled: true,
    //   name: 'Seller Management',
    //   path: '/seller-management',
    //   icon: <LocalShippingIcon sx={{ fontSize: 18 }} />,
    //   isChild: null,
    // },
    // {
    //   id: 108,
    //   enabled: true,
    //   name: 'Bid History',
    //   path: '/bid-history',
    //   icon: <GavelIcon sx={{ fontSize: 18 }} />,
    //   isChild: null,
    // },
    // {
    //     id: 109,
    //     enabled: true,
    //     name: "Help & Support",
    //     path: "/help-and-support",
    //     icon: <SupportAgentIcon sx={{ fontSize: 18 }} />,
    //     isChild: null
    // },
    // {
    //     id: 110,
    //     enabled: true,
    //     name: "Notification Management",
    //     path: "/notification-management",
    //     icon: <NotificationsActiveIcon sx={{ fontSize: 18 }} />,
    //     isChild: null
    // },
    // {
    //     id: 111,
    //     enabled: true,
    //     name: "Payment History",
    //     path: "/payment-history",
    //     icon: <AccountBalanceIcon sx={{ fontSize: 18 }} />,
    //     isChild: null
    // },

    // {
    //     id: 112,
    //     enabled: true,
    //     name: "CMS Management",
    //     path: "/cms-management",
    //     icon: <MessageIcon sx={{ fontSize: 18 }} />,
    //     isChild: null
    // },
    {
      id: 148,
      enabled: roleIsAdmin(role) || rightsInfo?.["activity-log-management"] === true,
      name: "Activity Log",
      path: ACTIVITY_LOG,
      icon: common.DASHBOARD_ICON,
      isChild: null,
    },
    {
      id: 149,
      enabled: roleIsAdmin(role) || rightsInfo?.["cron-jobs-management"] === true,
      name: "Cron Jobs",
      path: CRON_JOBS,
      icon: <ScheduleIcon sx={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 10101,
      enabled: showModule(
        rightsInfo?.["marketing-dashboard-management"],
        role
      ),
      name: "DASHBOARD",
      path: DASHBOARD_2,
      icon: common.MARKETING_DASHBOARD_ICON,
      isChild: null,
    },
    // Last in sidebar — admin only (no sub-admin right)
    {
      id: 1020,
      enabled: roleIsAdmin(role),
      name: "Claude Data Analysis",
      path: CLAUDE_DATA_ANALYSIS,
      icon: common.ANALYTICS_ICON,
      isChild: null,
    },
  ];

  let enabledSidebar = allSidebar.filter((data) => data.enabled);
  const onlyMarketingPaths = marketingOnlySidebarPaths(rightsInfo, role);
  if (onlyMarketingPaths) {
    enabledSidebar = enabledSidebar.filter((item) =>
      onlyMarketingPaths.includes(item.path)
    );
  }
  return enabledSidebar;
};

export const routes = (rightsInfo, role) => {
  const allRoutes = [
    {
      id: 123,
      // enabled: true,
      enabled: canAccessConsultantPayout(rightsInfo, role),
      element: <ConsultantPayout />,
      path: PAYOUT,
    },
    {
      id: 101,
      enabled: showModule(rightsInfo?.["dashboard-management"], role),
      name: "Dashboard",
      element: <Dashboard />,
      path: DASHBOARD,
    },
    {
      id: 1018,
      enabled: showOwnOrInherited(
        rightsInfo,
        role,
        ["daily-consult-performance", "daily-consult-performance-management"],
        ["dashboard-management"]
      ),
      name: "Daily Consult Performance",
      element: <DailyConsultPerformance />,
      path: DAILY_CONSULT_PERFORMANCE,
    },
    {
      id: 1019,
      enabled: roleIsAdmin(role) || rightsInfo?.["marketing-dashboard-management"] === true,
      name: "Power Customer",
      element: <PowerCustomer />,
      path: POWER_CUSTOMER,
    },
    {
      id: 200,
      enabled: showModule(rightsInfo?.["settings-management"], role),
      element: <Settings />,
      path: SETTINGS,
    },
    {
      id: 1011,
      enabled: role === "admin",
      name: "Enhanced Dashboard",
      element: <EnhancedDashboard />,
      path: "/enhanced-dashboard",
    },
    {
      id: 1012,
      enabled: role === "admin",
      name: "Analytics Dashboard",
      element: <AnalyticsDashboard />,
      path: "/analytics-dashboard",
    },
    {
      id: 1020,
      enabled: roleIsAdmin(role),
      name: "Claude Data Analysis",
      element: <ClaudeAnalysis />,
      path: CLAUDE_DATA_ANALYSIS,
    },
    {
      id: 1017,
      enabled: showModule(rightsInfo?.["dashboard-matrix-analytics"], role),
      name: "Dashboard Matrix Analytics",
      element: <DashboardMatrixAnalytics />,
      path: DASHBOARD_MATRIX_ANALYTICS,
    },
    {
      id: 102,
      enabled: canAccessManagementHub(rightsInfo, role),
      name: "Management",
      element: <Management />,
      path: MANAGEMENT,
    },
    //---------------User-Management--------------------
    {
      id: 102,
      // enabled: true,
      enabled: showModule(rightsInfo?.["user-management"], role),
      element: <UserManagement />,
      path: USER_MANAGEMENT,
    },
    {
      id: 102,
      // enabled: true,
      enabled: showModule(rightsInfo?.["user-management"], role),
      element: <DeleteUser />,
      path: USER_DELETE,
    },
    {
      id: 103,
      // enabled: true,
      enabled:
        showModule(rightsInfo?.["user-management"], role) ||
        rightsInfo?.["marketing-dashboard-management"] === true,
      element: <UserDetail />,
      path: `${USER_DETAIL}/:id`,
    },

    //-----------------------------------
    // {
    //   id: 102,
    //   enabled: true,
    //   element: <SubAdmin />,
    //   path: '/sub-admin',
    // },
    //---------------Consultant-Management--------------------
    {
      id: 103,
      // enabled: true,
      enabled: showModule(rightsInfo?.["consultant-management"], role),
      element: <ConsultantList />,
      path: CONSULTANT_MANAGEMENT,
    },
    {
      id: 104,
      // enabled: true,
      enabled: showModule(rightsInfo?.["consultant-management"], role),
      element: <AddConsultant />,
      path: CONSULTANT_ADD,
    },
    {
      id: 103,
      // enabled: true,
      enabled: showModule(rightsInfo?.["waitlist-management"], role),
      element: <WaitlistManagement />,
      path: WAITLIST_MANAGEMENT,
    },
    {
      id: 104,
      // enabled: true,
      enabled: showModule(rightsInfo?.["failed-consultation"], role),
      element: <FailedConsultation />,
      path: FAILED_CONSULTATION,
    },
    {
      id: 105,
      // enabled: true,
      enabled: showModule(rightsInfo?.["failed-consultation"], role),
      element: <MissedCall />,
      path: MISSED_CALL_CHAT,
    },
    {
      id: 106,
      // enabled: true,
      enabled: showModule(rightsInfo?.["progress-call-chat"], role),
      element: <ProgressCall />,
      path: PROGRESS_CALL_CHAT,
    },
    {
      id: 106,
      // enabled: true,
      enabled: showModule(rightsInfo?.["completed-call-chat"], role),
      element: <CompletedCall />,
      path: COMPLETED_CALL_CHAT,
    },
    {
      id: 10999,
      enabled: showOwnOrInherited(
        rightsInfo,
        role,
        ["completed-queries", "completed-queries-management"],
        ["completed-call-chat", "completed-call-chat-management"]
      ),
      element: <CompletedCall queryOnly />,
      path: COMPLETED_QUERIES,
    },
    {
      id: 106,
      // enabled: true,
      enabled: showModule(rightsInfo?.["online-offline-consultant"], role),
      element: <OnlineOffflineconsultant />,
      path: ONLINE_OFFLINE_CONSULTANT,
    },
    {
      id: 107,
      // enabled: true,
      enabled: showModule(rightsInfo?.["flag-request"], role),
      element: <FlagReview />,
      path: FLAG_REQUEST,
    },
    {
      id: 1008,
      // enabled: true,
      enabled: showModule(rightsInfo?.["support-management"], role),
      element: <SupportManagement />,
      path: SUPPORT_MANAGEMENT,
    },
    {
      id: 10081,
      enabled: showModule(rightsInfo?.["support-management"], role),
      element: <SupportQueryMasters />,
      path: QUERY_MASTERS,
    },
    {
      id: 108,
      // enabled: true,
      enabled: showOwnOrInherited(
        rightsInfo,
        role,
        ["booked-waitlist", "booked-waitlist-management"],
        ["waitlist-management"]
      ),
      element: <BookedWaitlistManagement />,
      path: BOOKED_WAITLIST,
    },
    {
      id: 10004,
      // enabled: true,
      enabled: showModule(rightsInfo?.["consultant-management"], role),
      element: <DeleteConsultant />,
      path: CONSULTANT_DELETE,
    },
    {
      id: 111,
      // enabled: true,
      enabled: canAccessConsultantProfileFromPreSelected(rightsInfo, role),
      element: <ConsultantDetail />,
      path: `${CONSULTANT_DETAIL}/:id`,
    },
    {
      id: 1111,
      // enabled: true,
      enabled: canAccessConsultantProfileFromPreSelected(rightsInfo, role),
      element: <EditConsultant />,
      path: `${CONSULTANT_EDIT}/:id`,
    },
    {
      id: 11111,
      // enabled: true,
      enabled: canAccessConsultantProfileFromPreSelected(rightsInfo, role),
      element: <EditConsultantV1 />,
      path: `${CONSULTANT_EDIT_V1}/:id`,
    },
    {
      id: 1111,
      // enabled: true,
      element: <CheckPerformance />,
      enabled: showModule(rightsInfo?.["consultant-management"], role),
      path: `${CONSULTANT_CHECK_PERFORMANCE}/:id/:name`,
    },
    // {
    {
      id: 1112,
      enabled: showModule(rightsInfo?.["consultant-management"], role),
      element: <ConsultantKPI />,
      path: `${CONSULTANT_KPI}/:id/:name?`,
    },
    {
      id: 1113,
      enabled: showModule(rightsInfo?.["consultant-management"], role),
      element: <ConsultantPerformance />,
      path: CONSULTANT_PERFORMANCE,
    },
    {
      id: 1114,
      enabled: showOwnOrInherited(
        rightsInfo,
        role,
        ["performance-alerts", "performance-alerts-management"],
        ["consultant-management"]
      ),
      element: <ConsultantPerformanceAlerts />,
      path: CONSULTANT_PERFORMANCE_ALERTS,
    },
    {
      id: 1115,
      enabled: canAccessOpsEcosystem(rightsInfo, role),
      element: <OperationsEcosystem />,
      path: OPERATIONS_ECOSYSTEM,
    },
    {
      id: 1116,
      enabled: canAccessPowerCustomerReturn(rightsInfo, role),
      element: <PowerCustomerReturn />,
      path: POWER_CUSTOMER_RETURN,
    },
    {
      id: 11101,
      // enabled: true,
      enabled: showModule(rightsInfo?.["consultant-management"], role),
      element: <ConsultantCommission />,
      path: `${COMMISSION}`,
    },
    //--------------sub-category---------------------
    {
      id: 104,
      // enabled: true,
      enabled: showModule(rightsInfo?.["expertise-management"], role),
      element: <Category />,
      path: CATEGORY,
    },
    {
      id: 105,
      // enabled: true,
      // element: <MantraList />,
      element: <MediaList />,
      path: `${ADD_MEDIA}/:id`,
    },

    //--------------Banner-management---------------------
    {
      id: 106,
      // enabled: true,
      enabled: showModule(rightsInfo?.["banner-management"], role),
      element: <BannerList />,
      path: BANNER,
    },
    {
      id: 1061,
      enabled: showModule(rightsInfo?.["ecommerce-management"], role),
      element: <EcommerceManagement />,
      path: ECOMMERCE,
    },

    // Music management
    {
      id: 107,
      // enabled: true,
      enabled: showModule(rightsInfo?.["music-management"], role),
      element: <MusicCategoryList />,
      path: MUSIC_LIST,
    },
    {
      id: 108,
      // enabled: true,
      enabled: showModule(rightsInfo?.["music-management"], role),
      element: <MusicList />,
      path: `${MUSIC_DETAIL}/:musicCategory/:id`,
    },

    // Meditation management
    {
      id: 109,
      // enabled: true,
      enabled: showModule(rightsInfo?.["meditation-management"], role),
      element: <Medication />,
      path: MEDITATION_LIST,
    },
    {
      id: 110,
      // enabled: true,
      enabled: showModule(rightsInfo?.["meditation-management"], role),
      element: <MeditationCategoryList />,
      path: MEDITATION_CATEGORY_LIST,
    },
    {
      id: 111,
      // enabled: true,
      enabled: showModule(rightsInfo?.["meditation-management"], role),
      element: <MeditationDashboard />,
      path: MEDITATION_DASHBOARD,
    },
    {
      id: 111,
      // enabled: true,
      enabled: showModule(rightsInfo?.["meditation-management"], role),
      element: <MeditationList />,
      path: `${MEDITATION_DETAIL}/:meditationCategory/:id`,
    },

    // Training
    {
      id: 112,
      enabled: showModule(rightsInfo?.["training-management"], role),
      // enabled: true,
      element: <TrainingCategoryList />,
      path: TRAINING_LIST,
    },
    {
      id: 112,
      enabled: showModule(rightsInfo?.["training-management"], role),
      // enabled: true,
      element: <TrainingList />,
      path: `${TRAINING_DETAIL}/:trainingCategory/:id`,
    },

    // image management
    {
      id: 113,
      // enabled: true,
      enabled: showModule(rightsInfo?.["gallery-management"], role),
      element: <ImageList />,
      path: IMAGE_LIST,
    },
    {
      id: 114,
      // enabled: true,
      enabled: showModule(rightsInfo?.["gallery-management"], role),
      element: <ImageDetail />,
      path: `${IMAGE_DETAIL}/:imageType/:id`,
    },
    // content management
    {
      id: 115,
      // enabled: true,
      enabled: showModule(rightsInfo?.["content-management"], role),
      element: <CmsManagement />,
      path: CONTENT_MANAGEMENT,
    },
    //  vastu compass management
    {
      id: 116,
      // enabled: true,
      enabled: showModule(rightsInfo?.["vastu-management"], role),
      element: <VastuCompassCategory />,
      path: VASTU_COMPASS_CATEGORY,
    },
    {
      id: 117,
      // enabled: true,
      enabled: showModule(rightsInfo?.["vastu-management"], role),
      element: <ViewVastuCompass />,
      path: `${VASTU_COMPASS_CATEGORY_DETAIL}/:id`,
    },
    {
      id: 118,
      // enabled: trueṛ
      enabled: showModule(rightsInfo?.["gift-management"], role),
      element: <GiftManagement />,
      path: GIFT_MANAGEMENT,
    },
    {
      id: 118,
      // enabled: true,
      enabled: showModule(rightsInfo?.["community-management"], role),
      element: <CommunityManagement />,
      path: COMMUNITY_MANAGEMENT,
    },
    {
      id: 119,
      // enabled: true,
      enabled: showModule(rightsInfo?.["community-management"], role),
      element: <CommunityDetail />,
      path: `${COMMUNITY_DETAIL}/:id`,
    },
    {
      id: 201,
      // enabled: true,
      enabled: showModule(rightsInfo?.["community-management"], role),
      element: <GoToChat />,
      path: `${COMMUNITY_CHAT}/:id`,
    },

    // explore management
    {
      id: 213,
      enabled: showModule(rightsInfo?.["explore-management"], role),
      element: <ExploreManagement />,
      path: EXPLORE_MANAGEMENT,
    },
    {
      id: 214,
      enabled: showModule(rightsInfo?.["explore-management"], role),
      element: <ViewExplore />,
      path: `${EXPLORE_DETAIL}/:id`,
    },
    // refer management
    {
      id: 215,
      enabled: showModule(rightsInfo?.["refer-management"], role),
      element: <ReferManagement />,
      path: REFER_MANAGEMENT,
    },
    // request management
    {
      id: 216,
      enabled: showModule(rightsInfo?.["request-management"], role),
      element: <RequestManagement />,
      path: REQUEST_MANAGEMENT,
    },
    // live management
    {
      id: 217,
      enabled: showModule(rightsInfo?.["live-management"], role),
      element: <LiveManagement />,
      path: LIVE_MANAGEMENT,
    },
    {
      id: 2171,
      enabled: canAccessPreSelectedConsultant(rightsInfo, role),
      element: <PreSelectedConsultant />,
      path: PRE_SELECTED_CONSULTANT,
    },
    {
      id: 2172,
      enabled: showOwnOrInherited(
        rightsInfo,
        role,
        ["astrologer-registration", "astrologer-registration-management"],
        ["pre-selected-consultant-management"]
      ),
      element: <AstrologerRegistrationFormList />,
      path: ASTROLOGER_REGISTRATION_FORM,
    },
    // notification management
    {
      id: 218,
      enabled: showModule(rightsInfo?.["notification-management"], role),
      element: <Notification />,
      path: NOTIFICATION_MANAGEMENT,
    },
    // Discount Management
    {
      id: 1003,
      // enabled: true,
      enabled: showModule(rightsInfo?.["discount-management"], role),
      element: <DiscountManagement />,
      path: DISCOUNT_MANAGEMENT,
    },

    // Feedback Management
    {
      id: 1010,
      // enabled: true,
      enabled: showModule(rightsInfo?.["feedback-management"], role),
      element: <FeedbackManagement />,
      path: FEEDBACK_MANAGEMENT,
    },

    // Concern & Remedy
    {
      id: 1009,
      // enabled: true,
      enabled: showModule(rightsInfo?.["concern-management"], role),
      element: <ConcernManagement />,
      path: CONCERN,
    },
    {
      id: 1010,
      // enabled: true,
      enabled: showModule(rightsInfo?.["concern-management"], role),
      element: <RemedyList />,
      path: `${CONCERN_DETAIL}/:concern/:id`,
    },

    // Offers Management
    {
      id: 1012,
      // enabled: true,
      enabled: showModule(rightsInfo?.["offers-management"], role),
      element: <OffersManagement />,
      path: OFFERS,
    },
    // Offer Engine
    {
      id: "offer-variants",
      enabled: showUnlessRevoked(rightsInfo, role, "offer-management"),
      name: "Offer Variants",
      element: <OfferVariantList />,
      path: OFFER_VARIANTS,
    },
    {
      id: "offer-rules",
      enabled: showUnlessRevoked(rightsInfo, role, "offer-management"),
      name: "Offer Rules",
      element: <OfferRuleList />,
      path: OFFER_RULES,
    },
    /// transaction management
    {
      id: 123,
      // enabled: true,
      enabled: showModule(rightsInfo?.["transaction-management"], role),
      name: "Transaction Management",
      path: TRANSACTION,
      element: <TransactionManagement />,
    },
    {
      id: 1013,
      // enabled: true,
      enabled: showModule(rightsInfo?.["sub-admin-management"], role),
      element: <SubAdmin />,
      path: SUBADMIN,
    },
    {
      id: 1014,
      // enabled: true,
      enabled: showModule(rightsInfo?.["sub-admin-management"], role),
      element: <AddSubadmin />,
      path: ADDSUBADMIN,
    },
    {
      id: 1015,
      // enabled: true,
      enabled: showModule(rightsInfo?.["sub-admin-management"], role),
      element: <ViewSubadmin />,
      path: VIEWSUBADMIN,
    },
    {
      id: 1016,
      // enabled: true,
      enabled: showModule(rightsInfo?.["sub-admin-management"], role),
      element: <EditSubadmin />,
      path: EDITSUBADMIN,
    },




    // {
    //   id: 1004,
    // enabled: true,
    //   element: <HoroscopeManagement />,
    //   path: HOROSCOPE_MANAGEMENT,
    // },
    {
      id: 1004,
      enabled: showModule(rightsInfo?.["horoscope-management"], role),
      element: <ViewHoroscope />,
      path: `${VIEW}/:id`,
    },

    {
      id: 1009,
      // enabled: true,
      enabled: showModule(rightsInfo?.["support-management"], role),
      element: <AddSupport />,
      path: ADD_SUPPORT,
    },
    {
      id: 1009,
      // enabled: true,
      enabled: showModule(rightsInfo?.["support-management"], role),
      element: <ViewSupport />,
      path: `${VIEW_SUPPORT}/:status/:id/:name/:userId/:threadId/:isResolved/:isAdminReply`,
    },
    {
      id: 1008,
      // enabled: true,
      enabled: showModule(rightsInfo?.["consultant-management"], role),
      element: <Form />,
      path: FORM,
    },
    {
      id: 100001,
      // enabled: true,
      enabled: showModule(rightsInfo?.["consultant-management"], role),
      element: <Shopify />,
      path: SHOPIFY,
    },
    {
      id: 1017,
      // enabled: true,
      enabled: showModule(rightsInfo?.["marketing-management"], role),
      element: <MarketingManagement />,
      path: MARKETING,
    },
    {
      id: 1018,
      enabled: showModule(rightsInfo?.["zodiac-message-management"], role),
      element: <ZodiacMessageManagement />,
      path: "/zodiac-message-management",
    },
    {
      id: 1018,
      // enabled: true,
      enabled: showModule(rightsInfo?.["insight-management"], role),
      element: <InsightManagement />,
      path: INSIGHT,
    },
    {
      id: 1019,
      // enabled: true,
      enabled: showModule(rightsInfo?.["insight-management"], role),
      element: <UserInsight />,
      path: USER_INSIGHT,
    },
    {
      id: 1020,
      // enabled: true,
      enabled: showModule(rightsInfo?.["insight-management"], role),
      element: <ConsultantInsight />,
      path: CONSULTANT_INSIGHT,
    },
    {
      id: 1021,
      enabled: showModule(rightsInfo?.["analytics-management"], role) || role === "admin",
      element: <AnalyticsManagement />,
      path: ANALYTICS,
    },
    {
      id: "user-analytics",
      path: "/analytics-management/user/:userId",
      enabled: showModule(rightsInfo?.["analytics-management"], role) || role === "admin",
      element: <UserAnalytics />,
    },
    {
      id: "device-analytics",
      path: "/analytics-management/device/:deviceId",
      enabled: showModule(rightsInfo?.["analytics-management"], role) || role === "admin",
      element: <DeviceAnalytics />,
    },
    {
      id: "purchase-analytics",
      enabled: showModule(rightsInfo?.["purchase-analytics-management"], role),
      name: "Purchase Analytics",
      element: <PurchaseAnalytics />,
      path: purchaseAnalytics.PURCHASE_ANALYTICS,
    },
    {
      id: "users-by-purchase-count",
      enabled: showModule(rightsInfo?.["purchase-analytics-management"], role),
      name: "Users by Purchase Count",
      element: <UsersByPurchaseCount />,
      path: purchaseAnalytics.USERS_BY_PURCHASE_COUNT,
    },
    // Segment Management
    {
      id: "segment-list",
      enabled: showModule(rightsInfo?.["segment-management"], role) || role === "admin",
      name: "Segment List",
      element: <SegmentList />,
      path: segment.SEGMENT_LIST,
    },
    {
      id: "segment-builder",
      enabled: showModule(rightsInfo?.["segment-management"], role) || role === "admin",
      name: "Segment Builder",
      element: <SegmentBuilder />,
      path: `${segment.SEGMENT_BUILDER}/:id?`,
    },
    {
      id: "segment-detail",
      enabled: showModule(rightsInfo?.["segment-management"], role) || role === "admin",
      name: "Segment Detail",
      element: <SegmentDetail />,
      path: `${segment.SEGMENT_DETAIL}/:id`,
    },
    {
      id: "playstore-screenshot",
      enabled: showModule(rightsInfo?.["playstore-screenshot-management"], role) || role === "admin",
      name: "Playstore Screenshot Management",
      element: <PlaystoreScreenshotManagement />,
      path: PLAYSTORE_SCREENSHOT,
    },
    {
      id: 145,
      enabled: showModule(rightsInfo?.["utm-management"], role),
      name: "UTM Management",
      element: <UTMManagement />,
      path: UTM_MANAGEMENT,
    },
    // ── V2 Coupon System ──────────────────────────────────────────────────────
    {
      id: "coupons-v2",
      enabled: showUnlessRevoked(rightsInfo, role, "coupon-management-v2"),
      name: "Coupon Management V2",
      element: <CouponsV2Management />,
      path: COUPONS_V2,
    },
    {
      id: "influencer-list",
      enabled: showUnlessRevoked(rightsInfo, role, "influencer-management"),
      name: "Influencer Management",
      element: <InfluencerManagement />,
      path: INFLUENCER_LIST,
    },
    {
      id: "influencer-detail",
      enabled: showUnlessRevoked(rightsInfo, role, "influencer-management"),
      name: "Influencer Detail",
      element: <InfluencerDetail />,
      path: `${INFLUENCER_DETAIL}`,
    },
    {
      id: 146,
      enabled: showModule(rightsInfo?.["customer-problem-management"], role),
      name: "Customer Problem Identification",
      element: <CustomerProblemIdentification />,
      path: CUSTOMER_PROBLEM,
    },
    {
      id: 147,
      enabled: roleIsAdmin(role) || rightsInfo?.["activity-log-management"] === true,
      name: "Activity Log",
      element: <ActivityLogPage />,
      path: ACTIVITY_LOG,
    },
    {
      id: 149,
      enabled: roleIsAdmin(role) || rightsInfo?.["cron-jobs-management"] === true,
      name: "Cron Jobs",
      element: <CronJobsPage />,
      path: CRON_JOBS,
    },
    {
      id: 10101,
      enabled: showModule(
        rightsInfo?.["marketing-dashboard-management"],
        role
      ),
      name: "DASHBOARD",
      element: <Dashboard2 />,
      path: DASHBOARD_2,
    },
  ];

  let enabledRoutes = allRoutes.filter((data) => data.enabled);
  const marketingOnlyPaths = marketingOnlySidebarPaths(rightsInfo, role);
  if (marketingOnlyPaths) {
    enabledRoutes = enabledRoutes.filter((r) =>
      marketingOnlyPaths.includes(r.path)
    );
  }
  return enabledRoutes;
};
